module.exports = __webpack_public_path__ + "static/media/burger_family_deals-dt-fr.b42c2cee.jpg";